(ns kyber.components.composite.expander
  (:require [applied-science.js-interop :as j]
            [reagent.core :as r]

            [kyber.styles.core :refer [styles->classes gs]]
            [kyber.components.base.icons :as icon]))

(def classes
  (styles->classes
   {:header
    {:display :flex
     :cursor :pointer
     :align-items :center
     :padding (gs [:spacing :p8])

     "& > *:first-child"
     {:margin-right (gs [:spacing :p12])
      :width (gs [:spacing :p20])}

     "&:hover"
     {:background-color (gs [:colors :gray-scale-100])}}

    :body
    {:max-height 0
     :overflow :hidden
     :transition "max-height 0.25s ease-in-out"}

    :button
    {:appearance :none
     :cursor :pointer
     :border :none
     :background :none}}))

(defn render
  [{:keys [default-open body]
    :or {default-open false}}]
  (let [is-open (r/atom default-open)
        scroll-height (r/atom 0)
        !ref (atom nil)
        current-body (atom body)

        set-scroll-height!
        #(reset! scroll-height (inc (j/get @!ref :scrollHeight)))

        remove-max-height!
        #(when @is-open
           (set! (.-maxHeight (j/get @!ref :style)) "none"))

        set-event-listener!
        #(j/call @!ref % "transitionend" remove-max-height!)

        reset-max-height!
        #(set! (.-maxHeight (j/get @!ref :style))
               (str (set-scroll-height!) "px"))]
    (r/create-class
     {:component-did-mount #(do
                              (set-event-listener! :addEventListener)
                              (set-scroll-height!))
      :component-will-unmount #(set-event-listener! :removeEventListener)
      :reagent-render
      (fn [{:keys [header body]}]
        (let [_ (when (not= body @current-body)
                  (reset! is-open false)
                  (reset! current-body body))]
          [:<>
           [:div {:class (:header classes)
                  :on-click #(do
                               (when @is-open (reset-max-height!))
                               (swap! is-open not))}
            [:button {:on-click (fn [e]
                                  (j/call e :stopPropagation)
                                  (when @is-open (reset-max-height!))
                                  (swap! is-open not))
                      :class (:button classes)
                      :aria-expanded (str @is-open)
                      :aria-label (if @is-open "Collapse" "Expand")}
             [icon/icon (if @is-open :chevron-down :chevron-right)]]
            header]
           [:div (cond-> {:ref #(reset! !ref %)
                          :class (:body classes)}
                   @is-open
                   (assoc :style
                          {:max-height (str @scroll-height "px")}))
            body]]))})))
